const TRAINING_SHORT_STATUSES = {
  available: {
    label: 'Available',
    indicatorType: 'success',
  },
  inProduction: {
    label: 'Draft',
    indicatorType: 'pending',
  },
  planned: {
    label: 'Planned',
    indicatorType: 'info',
  },
};

const buildSynthesiaEmbedUrl = videoId =>
  videoId ? `https://share.synthesia.io/embeds/videos/${encodeURIComponent(videoId)}` : null;

const TRAINING_SHORTS = [
  {
    id: 'activating-imported-participants',
    title: 'Activating imported participants',
    description: 'Activate imported participant records for casework.',
    topic: 'Participant records',
    audience: 'Casework staff',
    duration: '1 min 16 sec',
    durationSeconds: 76,
    status: 'available',
    host: 'Synthesia',
    lastReviewed: '2026-06-07',
    synthesiaVideoId: '1fd5e05c-d922-4570-8652-446bd2269c6f',
    embedUrl: buildSynthesiaEmbedUrl('1fd5e05c-d922-4570-8652-446bd2269c6f'),
    shareUrl: null,
  },
  {
    id: 'approvals-process',
    title: 'Approvals process',
    description: 'Review PATH approval flow and decision handoffs.',
    topic: 'Approvals',
    audience: 'Assessment and approval staff',
    duration: '5 min 39 sec',
    durationSeconds: 339,
    status: 'available',
    host: 'Synthesia',
    lastReviewed: '2026-06-07',
    synthesiaVideoId: 'cad99c5b-b622-4b79-abc7-b5de033387de',
    embedUrl: buildSynthesiaEmbedUrl('cad99c5b-b622-4b79-abc7-b5de033387de'),
    shareUrl: null,
  },
  {
    id: 'backloading-interventions',
    title: 'Backloading interventions',
    description: 'Enter historical action plans and interventions.',
    topic: 'Case management',
    audience: 'Casework staff',
    duration: '2 min 43 sec',
    durationSeconds: 163,
    status: 'available',
    host: 'Synthesia',
    lastReviewed: '2026-06-07',
    synthesiaVideoId: '224f348d-db6d-4e8c-957d-0376e481211f',
    embedUrl: buildSynthesiaEmbedUrl('224f348d-db6d-4e8c-957d-0376e481211f'),
    shareUrl: null,
  },
  {
    id: 'job-search',
    title: 'Job search',
    description: 'Record job-search activity.',
    topic: 'Case management',
    audience: 'Casework staff',
    duration: '54 sec',
    durationSeconds: 54,
    status: 'available',
    host: 'Synthesia',
    lastReviewed: '2026-06-07',
    synthesiaVideoId: 'e17126dc-6db8-433f-9cd8-422c89cf8662',
    embedUrl: buildSynthesiaEmbedUrl('e17126dc-6db8-433f-9cd8-422c89cf8662'),
    shareUrl: null,
  },
  {
    id: 'ilmp-submissions-preparing-export',
    title: 'ILMP submissions: preparing an export',
    description: 'Validate the queue, fix blocked records, and download the ILMP XML for manual ESDC upload.',
    topic: 'ILMP reporting',
    audience: 'Reporting and administration staff',
    duration: '58 sec',
    durationSeconds: 58,
    status: 'inProduction',
    host: 'Synthesia',
    lastReviewed: null,
    synthesiaVideoId: '4c3c1361-6e57-4bf9-aab1-37ae9232bd8c',
    embedUrl: buildSynthesiaEmbedUrl('4c3c1361-6e57-4bf9-aab1-37ae9232bd8c'),
    shareUrl: null,
  },
  {
    id: 'ilmp-validation-repairs',
    title: 'ILMP validation and repairs',
    description: 'Use Case Workspace validation to find blockers, repair case data, and rerun checks.',
    topic: 'ILMP reporting',
    audience: 'Casework and reporting staff',
    duration: '1 min 3 sec',
    durationSeconds: 63,
    status: 'inProduction',
    host: 'Synthesia',
    lastReviewed: null,
    synthesiaVideoId: '77a83dc0-284b-4978-abdb-15a2f8b3d8cf',
    embedUrl: buildSynthesiaEmbedUrl('77a83dc0-284b-4978-abdb-15a2f8b3d8cf'),
    shareUrl: null,
  },
  {
    id: 'manual-intake',
    title: 'Manual intake',
    description: 'Create applications entered by staff.',
    topic: 'Application intake',
    audience: 'Intake staff',
    duration: '1 min 15 sec',
    durationSeconds: 75,
    status: 'available',
    host: 'Synthesia',
    lastReviewed: '2026-06-07',
    synthesiaVideoId: '443faef9-ce35-4f0a-a461-8bc1da18044d',
    embedUrl: buildSynthesiaEmbedUrl('443faef9-ce35-4f0a-a461-8bc1da18044d'),
    shareUrl: null,
  },
  {
    id: 'metrics-reporting',
    title: 'Metrics and reporting',
    description: 'Use PATH reporting metrics.',
    topic: 'Reporting',
    audience: 'Program and reporting staff',
    duration: '2 min 13 sec',
    durationSeconds: 133,
    status: 'available',
    host: 'Synthesia',
    lastReviewed: '2026-06-07',
    synthesiaVideoId: 'fd4b1116-6be6-415f-b4a6-ce79be26cffc',
    embedUrl: buildSynthesiaEmbedUrl('fd4b1116-6be6-415f-b4a6-ce79be26cffc'),
    shareUrl: null,
  },
  {
    id: 'payments',
    title: 'Payments',
    description: 'Process and track payment requests.',
    topic: 'Payments',
    audience: 'PATH casework and program staff',
    duration: '1 min 51 sec',
    durationSeconds: 111,
    status: 'available',
    host: 'Synthesia',
    lastReviewed: '2026-06-07',
    synthesiaVideoId: '85aa5719-3874-463c-8d50-91eb43020a1c',
    embedUrl: buildSynthesiaEmbedUrl('85aa5719-3874-463c-8d50-91eb43020a1c'),
    shareUrl: null,
  },
  {
    id: 'regional-snapshots',
    title: 'Regional snapshots',
    description: 'Review regional activity snapshots.',
    topic: 'Reporting',
    audience: 'Regional and program staff',
    duration: '35 sec',
    durationSeconds: 35,
    status: 'available',
    host: 'Synthesia',
    lastReviewed: '2026-06-07',
    synthesiaVideoId: 'c70bd39f-2563-4977-aa22-ffe9577a4bb3',
    embedUrl: buildSynthesiaEmbedUrl('c70bd39f-2563-4977-aa22-ffe9577a4bb3'),
    shareUrl: null,
  },
  {
    id: 'withdrawing-reopening-application',
    title: 'Withdrawing and reopening an application',
    description: 'Withdraw when review stops; reopen if it should continue.',
    topic: 'Application assessment',
    audience: 'Application assessment staff',
    duration: '40 sec',
    durationSeconds: 40,
    status: 'inProduction',
    host: 'Synthesia',
    lastReviewed: null,
    synthesiaVideoId: 'c2cd268c-ad84-48cb-84a9-588f515d9a90',
    embedUrl: buildSynthesiaEmbedUrl('c2cd268c-ad84-48cb-84a9-588f515d9a90'),
    shareUrl: null,
  },
];

const getTrainingShortStatusMeta = status =>
  TRAINING_SHORT_STATUSES[status] || TRAINING_SHORT_STATUSES.planned;

const isTrainingShortPublished = trainingShort =>
  trainingShort?.status === 'available' &&
  Boolean(trainingShort?.embedUrl || buildSynthesiaEmbedUrl(trainingShort?.synthesiaVideoId));

const isTrainingShortWatchable = trainingShort =>
  Boolean(trainingShort?.embedUrl || buildSynthesiaEmbedUrl(trainingShort?.synthesiaVideoId));

const getTrainingShortEmbedUrl = trainingShort =>
  trainingShort?.embedUrl || buildSynthesiaEmbedUrl(trainingShort?.synthesiaVideoId);

export {
  TRAINING_SHORTS,
  getTrainingShortEmbedUrl,
  getTrainingShortStatusMeta,
  isTrainingShortPublished,
  isTrainingShortWatchable,
};
